module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic--CH-6ba27df627511f82f429ee42a9e47167.jpg";